// src/pages/Presidente/PresidentePage.jsx
import React from 'react';
import PresidenteList from '../../components/Presidente/PresidenteList';
import { Link } from 'react-router-dom';

const PresidentePage = () => {
    return (
        <div>
            <h1>Gestão de Presidentes</h1>
            <Link to="/presidentes/nomear">Nomear Novo Presidente</Link>
            <PresidenteList />
        </div>
    );
};

export default PresidentePage;
